import { _ as __assign } from './chunks/bundle-C7jYHvwG.js';
import React__default from 'react';
import { GroupChannelProvider } from './GroupChannel/context.js';
import { GroupChannelUI } from './GroupChannel/components/GroupChannelUI.js';
import '@sendbird/chat/message';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import './chunks/bundle-gQ2a8Eki.js';
import './withSendbird.js';
import './chunks/bundle-MyLy9AIu.js';
import './chunks/bundle-DYeeW5nS.js';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-CDjVXDOc.js';
import './chunks/bundle-Dl9NVsui.js';
import './chunks/bundle-DkviGBGz.js';
import './chunks/bundle-DUTyBaXr.js';
import 'react-dom';
import './chunks/bundle-CIN9yQRB.js';
import './chunks/bundle-pOZPN8hk.js';
import './chunks/bundle-DfDrbjM5.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-DImSV9VW.js';
import './ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-CLonR-iH.js';
import './useSendbirdStateContext.js';
import './chunks/bundle-C6-Ix-Lk.js';
import './ui/SortByRow.js';
import './chunks/bundle-MrMJJXf2.js';
import './chunks/bundle-ryUmMhVP.js';
import './chunks/bundle-C1U8wE49.js';
import './chunks/bundle-Dpdq7qeD.js';
import './chunks/bundle-90vsNbxW.js';
import './chunks/bundle-MkyS3j4-.js';
import './chunks/bundle-LPNnEgGp.js';
import './chunks/bundle-CDvvzlad.js';
import './GroupChannel/components/TypingIndicator.js';
import './chunks/bundle-BP1CB0js.js';
import './ui/ConnectionStatus.js';
import './ui/PlaceHolder.js';
import './ui/Loader.js';
import './GroupChannel/components/GroupChannelHeader.js';
import './chunks/bundle-BAQj91eb.js';
import './ui/ChannelAvatar.js';
import './chunks/bundle-CbEyAimK.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-BR3O1lZq.js';
import './chunks/bundle-TGosz9cX.js';
import './chunks/bundle-DvcOxLrR.js';
import './ui/Header.js';
import './ui/TextButton.js';
import './chunks/bundle-Ci2fMtNJ.js';
import './GroupChannel/components/MessageList.js';
import './GroupChannel/components/Message.js';
import './chunks/bundle-CJBs1h8R.js';
import './chunks/bundle-BeUKuH7h.js';
import './Message/hooks/useDirtyGetMentions.js';
import './ui/DateSeparator.js';
import './ui/MessageInput.js';
import './chunks/bundle-C9dF4QVS.js';
import './chunks/bundle-DCX2mqfp.js';
import 'dompurify';
import './chunks/bundle-BMygDCXK.js';
import './chunks/bundle-P-vXuw8U.js';
import './chunks/bundle-BBowfNDO.js';
import './chunks/bundle-_-FiwcfQ.js';
import './ui/MessageContent.js';
import './chunks/bundle-BH8ohfFx.js';
import './chunks/bundle-Bzt5nDi4.js';
import './chunks/bundle-yLTgHCRG.js';
import './chunks/bundle-3aUfVJHj.js';
import './ui/MessageItemReactionMenu.js';
import './ui/ReactionButton.js';
import './chunks/bundle-eYHtE5ry.js';
import './ui/EmojiReactions.js';
import './ui/ReactionBadge.js';
import './ui/BottomSheet.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './ui/Tooltip.js';
import './ui/TooltipWrapper.js';
import './Message/context.js';
import './ui/AdminMessage.js';
import './ui/QuoteMessage.js';
import './chunks/bundle-jw_xHmHg.js';
import './ui/MobileMenu.js';
import './ui/ThreadReplies.js';
import './chunks/bundle-BXE5p6Kc.js';
import './ui/OGMessageItemBody.js';
import './chunks/bundle-k6zcGkBp.js';
import './ui/MentionLabel.js';
import './ui/LinkLabel.js';
import './ui/TextMessageItemBody.js';
import './ui/FileMessageItemBody.js';
import './chunks/bundle-Crm9sJrW.js';
import './ui/FileViewer.js';
import './chunks/bundle-BiPxcZtH.js';
import './ui/VoiceMessageItemBody.js';
import './ui/ProgressBar.js';
import './VoicePlayer/useVoicePlayer.js';
import './ui/PlaybackTime.js';
import './ui/ThumbnailMessageItemBody.js';
import './ui/UnknownMessageItemBody.js';
import './ui/TemplateMessageItemBody.js';
import './chunks/bundle-Er6ifVzM.js';
import './ui/FallbackTemplateMessageItemBody.tsx.js';
import './ui/LoadingTemplateMessageItemBody.tsx.js';
import './ui/MessageFeedbackFailedModal.js';
import './ui/FeedbackIconButton.js';
import './ui/MobileFeedbackMenu.js';
import './ui/MessageFeedbackModal.js';
import './ui/Input.js';
import './chunks/bundle-DaKZZ13Y.js';
import './GroupChannel/components/SuggestedReplies.js';
import './chunks/bundle-BL_0pgq0.js';
import './GroupChannel/components/FileViewer.js';
import './chunks/bundle-LWpHaUiZ.js';
import './GroupChannel/components/RemoveMessageModal.js';
import './chunks/bundle-Dvg19muo.js';
import './chunks/bundle-DCbJaskZ.js';
import './GroupChannel/components/UnreadCount.js';
import './GroupChannel/components/FrozenNotification.js';
import './ui/TypingIndicatorBubble.js';
import './Channel/utils/getMessagePartsInfo.js';
import './Channel/utils/compareMessagesForGrouping.js';
import './chunks/bundle-Deel9XzY.js';
import './GroupChannel/components/MessageInputWrapper.js';
import './chunks/bundle-DRyEkedz.js';
import './GroupChannel/components/SuggestedMentionList.js';
import './ui/QuoteMessageInput.js';
import './VoiceRecorder/useVoiceRecorder.js';
import './chunks/bundle-CTE4m7bC.js';
import './chunks/bundle-2kzSicIw.js';

var GroupChannel = function (props) {
    return (React__default.createElement(GroupChannelProvider, __assign({}, props),
        React__default.createElement(GroupChannelUI, __assign({}, props))));
};

export { GroupChannel, GroupChannel as default };
//# sourceMappingURL=GroupChannel.js.map
